﻿package com.mgacreative.hotelru.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.domain.model.BlacklistedGuest
import com.mgacreative.hotelru.domain.repository.BlacklistRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AdminBlacklistViewModel(
    private val blacklistRepository: BlacklistRepository
) : ViewModel() {

    private val _blacklistedGuests = MutableStateFlow<List<BlacklistedGuest>>(emptyList())
    val blacklistedGuests: StateFlow<List<BlacklistedGuest>> = _blacklistedGuests.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    init {
        loadBlacklist()
    }

    fun loadBlacklist() {
        viewModelScope.launch {
            _isLoading.value = true
            try {
                _blacklistedGuests.value = blacklistRepository.getBlacklistedGuests()
            } catch (e: Exception) {
                e.printStackTrace()
            } finally {
                _isLoading.value = false
            }
        }
    }

    fun addBlacklistRecord(fullName: String, identityNo: String, reason: String) {
        viewModelScope.launch {
            val record = BlacklistedGuest(
                fullName = fullName.trim(),
                identityNo = identityNo.trim(),
                reason = reason.trim(),
                createdAt = "26.07.2026"
            )
            blacklistRepository.addBlacklistedGuest(record)
            loadBlacklist()
        }
    }

    fun removeBlacklistRecord(id: String) {
        viewModelScope.launch {
            blacklistRepository.deleteBlacklistedGuest(id)
            loadBlacklist()
        }
    }
}

